<template>
<div style="margin-bottom: 2px;">
    <!-- <div class="columns" v-show="!isEditing">
        <div class="column">{{ data.firstName }} {{ data.lastName }}</div>
        <div class="column is-2">
            <b-button type="is-info is-small is-light" v-on:click="viewSubmissions(data)" style="margin-right: 5px;" icon-right="book"/>
            <b-button type="is-info is-small is-light" v-on:click="editData(data)" style="margin-right: 5px;" icon-right="edit"/>
            <b-button type="is-info is-small is-light" v-on:click="deleteData(data)" style="margin-right: 5px;" icon-right="trash-alt"/>
        </div>
    </div> -->

    <table class="table" style="cellpadding: 0 !important; cellspacing: 0 !important;"><tbody>
        <tr v-show="dataIndex == 0">
            <Td class="custom-td-header">Name</Td>
            <Td class="custom-td-header">Father</Td>
            <Td class="custom-td-header">Father's ID</Td>
            <Td class="custom-td-header">Email</Td>
            <Td class="custom-td-header">Mother</Td>
            <Td class="custom-td-header">Mother's ID</Td>
            <Td class="custom-td-header">Email</Td>
            <Td class="custom-td-header">Phone</Td>
        </tr>
        <tr>
            <Td class="custom-td" style="width: 300px;"><input class="input is-success" type="text" placeholder="First Name" v-model="data.firstName"></Td>
            <td class="custom-td"><input class="input is-success" type="text" placeholder="Father's Name" v-model="data.father"></td>
            <td class="custom-td"><input class="input is-success" type="text" placeholder="Father's ID/IC (Only letters and numbers)" v-model="data.fatherID"></td>
            <td class="custom-td"><input class="input is-success" type="text" placeholder="Father's E-mail" v-model="data.fatherEmail"></td>
            <td class="custom-td"><input class="input" type="text" placeholder="Mother's Name" v-model="data.mother"></td>
            <td class="custom-td"><input class="input" type="text" placeholder="Mother's ID/IC (Only letters and numbers)" v-model="data.motherID"></td>
            <td class="custom-td"><input class="input is-success" type="text" placeholder="Mother's E-mail" v-model="data.motherEmail"></td>
            <td class="custom-td" style="width: 100px;"><input class="input is-success" type="text" placeholder="Contact #" v-model="data.contactNo1"></td>
            <td class="custom-td"><b-button type="is-primary" v-on:click="updateData(data)">Update</b-button></td>
            <td class="custom-td"><b-button type="is-info" v-on:click="viewSubmissions(data)" icon-right="book"/></td>
            <!-- <td class="custom-td"><b-button type="is-danger is-light" v-on:click="deleteData(data)" icon-right="trash-alt"/></td> -->
        </tr>
    </tbody></table>

    <!-- <div class="columns" style="border: 1px solid #CCC; padding: 10px;" v-show="isEditing">
        
        <div class="column">
            <div class="field">
                <div class="control">
                    <input class="input is-success" type="text" placeholder="First Name" v-model="data.firstName">
                </div>
            </div>
            <div class="field">
                <div class="control">
                    <input class="input" type="text" placeholder="Last Name" v-model="data.lastName">
                </div>
            </div>
            <div class="field">
                <div class="control">
                    <input class="input is-success" type="text" placeholder="Father's Name" v-model="data.father">
                </div>
            </div>
            <div class="field">
                <div class="control">
                    <input class="input is-success" type="text" placeholder="Father's ID/IC (Accept on letters and numbers)" v-model="data.fatherID">
                </div>
                <small><i>Use this ID to login from parents app</i></small>
            </div>
            <div class="field">
                <div class="control">
                    <input class="input is-success" type="text" placeholder="Father's E-mail" v-model="data.fatherEmail">
                </div>
            </div>
            <div class="field">
                <div class="control">
                    <input class="input" type="text" placeholder="Mother's Name" v-model="data.mother">
                </div>
            </div>
            <div class="field">
                <div class="control">
                    <input class="input" type="text" placeholder="Mother's ID/IC (Accept on letters and numbers)" v-model="data.motherID">
                </div>
                <small><i>Use this ID to login from parents app</i></small>
            </div>
            <div class="field">
                <div class="control">
                    <input class="input is-success" type="text" placeholder="Mother's E-mail" v-model="data.motherEmail">
                </div>
            </div>
            <div class="field">
                <div class="control">
                    <input class="input is-success" type="text" placeholder="Contact Number" v-model="data.contactNo1">
                </div>
            </div>
            <div class="columns">
                <div class="column is-1"><button class='button is-primary' v-on:click="updateData(data)">Update</button></div>
                <div class="column is-1"><button class='button is-secondary' v-on:click="cancelEdit()">Close</button></div>
                <div class="column">
                    <b-notification type="is-success" :closable="false" style="padding: 10px; font-size: 12px;">
                        <center>Download parent app <a v-on:click="goExternalPage(1)">here.</a> View parent's app tutorial <a v-on:click="goExternalPage(2)">here.</a></center>
                    </b-notification>
                </div>
            </div>
        </div>        
    </div> -->
</div>
</template>

<script>
export default {
    props: ['data','dataIndex'],
    data() {
        return {
        };
    },
    methods: {
        completeData(data) {
            this.$emit('complete-data', data);
        },
        viewSubmissions(data) {
            this.$emit('view-submissions', data);
        },
        deleteData(data) {
            this.$emit('delete-data', data);
        },
        // editData() {
        //     this.isEditing = true;
        // },
        // cancelEdit(){
        //     this.isEditing = false;
        // },
        updateData(data) {
            this.$emit('update-data', data);
            // this.isEditing = false;
        },
        goExternalPage(where){
            if (where == 1){
                window.open("https://www.studentqr.com/download", '_blank');
            }else{
                window.open("https://www.studentqr.com/parent", '_blank');
            }
        },
    },
};
</script>
<style>
.custom-td-header{
   padding: 1px !important;
   margin: 0px !important;
   padding-left: 5px !important;
}
.custom-td{
   padding: 1px !important;
   margin: 0px !important; 
}
</style>



// WEBPACK FOOTER //
// src/components/Manage/Students/StudentView.vue